<div class="note">
  <mat-form-field appearance="standard">
    <textarea #noteText [(ngModel)]="note" matInput [placeholder]="'Add a comment'" matTextareaAutosize></textarea>
  </mat-form-field>
  <div *ngIf="noteText.value">
    <button class="auto" mat-button type="submit" (click)="doSave(noteText.value)" color="primary">Save</button>
    <button class="auto" mat-button type="button" (click)="doCancel()" color="accent">Cancel</button>
  </div>
</div>
